import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LoginPage } from "@/pages/Login";
import { SignUpPage } from "@/pages/SignUp";
import { VerifyOtpPage } from "@/pages/VerifyOtp";
import { UserInfoPage } from "@/pages/UserInfo";
import { ForgotPasswordPage } from "@/pages/ForgotPassword";
import { ResetPasswordPage } from "@/pages/ResetPassword";
import { UnauthenticatedRoute } from "./UnauthenticatedRoute";
import { paths } from "./paths";
import { NotFoundPage } from "@/pages/NotFound";
import { AuthenticatedRoute } from "./AuthenticatedRoute";
import { UserBookingsPage } from "@/pages/UserBookings";
import { Layout } from "@/components/navigation/Layout";
import { BookSlot } from "@/pages/BookSlot";

export const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route
          path={paths.ROOT}
          element={<Navigate to={paths.USER_BOOKINGS} replace />}
        />
        <Route
          path={paths.LOGIN}
          element={
            <UnauthenticatedRoute>
              <LoginPage />
            </UnauthenticatedRoute>
          }
        />
        <Route
          path={paths.SIGN_UP}
          element={
            <UnauthenticatedRoute>
              <SignUpPage />
            </UnauthenticatedRoute>
          }
        />
        <Route
          path={paths.VERIFY_OTP}
          element={
            <UnauthenticatedRoute>
              <VerifyOtpPage />
            </UnauthenticatedRoute>
          }
        />
        <Route
          path={paths.USER_INFO}
          element={
            <UnauthenticatedRoute>
              <UserInfoPage />
            </UnauthenticatedRoute>
          }
        />
        <Route
          path={paths.FORGOT_PASSWORD}
          element={
            <UnauthenticatedRoute>
              <ForgotPasswordPage />
            </UnauthenticatedRoute>
          }
        />
        <Route
          path={paths.RESET_PASSWORD}
          element={
            <UnauthenticatedRoute>
              <ResetPasswordPage />
            </UnauthenticatedRoute>
          }
        />
        <Route
          path={paths.USER_BOOKINGS}
          element={
            <AuthenticatedRoute>
              <Layout>
                <UserBookingsPage />
              </Layout>
            </AuthenticatedRoute>
          }
        />
        <Route
          path={paths.BOOK_SLOT}
          element={
            <AuthenticatedRoute>
              <Layout>
                <BookSlot />
              </Layout>
            </AuthenticatedRoute>
          }
        />
        <Route path={paths.NOT_FOUND} element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to={paths.NOT_FOUND} />} />
      </Routes>
    </Router>
  );
};
